import db from "@/plugins/dexie";
import api from '@/services/api-recebimentoweb';

const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n) {
    u8arr[n - 1] = bstr.charCodeAt(n - 1);
    n -= 1; // to make eslint happy
  }
  return new File([u8arr], filename, { type: mime });
};

export default async function $_enviaImagem() {
  let imagens = await db.imagem.toArray();

  // Cria um array de Promises
  const promises = imagens.map(async (item) => {

    if (item.tentativa >= 3) {
      await db.imagem.where({id: item.id}).delete();
      return;
    }    

    const file = await dataURLtoFile(item.base64);
    const formData = new FormData();
    formData.append('image', file, item.nomearquivo);

    let res;
    try {
      res = await api.post(item.rotaapi, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      await db.imagem.where({id: item.id}).delete();
    } catch (err) {
      console.log(err);
      await db.imagem.update(item.id, {
        tentativa: item.tentativa + 1,
      });
    }

    if (res) {
      await db.imagem.where({id: item.id}).delete();
    }

  });

  // Aguarda todas as requisições terminarem
  await Promise.all(promises);

}
